import { Component, Input, OnInit} from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { LineInterface } from '../../../../lines/models/line.interface';
import { PriceDetailsInterface } from '../../../models/price-details.interface';
import { CustomerInterface } from '../../../../account/models/customer.interface';

@Component({
  selector: 'app-recharge-data',
  templateUrl: './recharge-data.component.html',
  styleUrls: ['./recharge-data.component.css'],
  standalone: false
})
export class RechargeDataComponent implements OnInit {
  environment = environment;

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  @Input()
  priceDetails?: PriceDetailsInterface;

  @Input()
  customer: CustomerInterface;
  constructor() {}

  ngOnInit() {
  }
}
